import {
  Component,
} from "react";

import {
  Awesome,
} from "CommonComponents/bricks";
import helpApi, {
  isUrlMatch,
} from "Apis/help-api";
import {
  openWindow,
} from "CommonCore/util";
import {
  converter,
} from "CommonComponents/markdown-editor";
import store from "CommonState/store";

import _ from "lodash";

@helpApi.list
@store("flag_antragstellermodus")
export default class ContextHelpButton extends Component {
  render() {
    const { article } = this;
    const style = article
? {}
: {
  pointerEvents: "none",
  opacity: 0.3,
};

    if (!article || !article.hi_text || article.hi_hidden) {
      return null;
    }
    return (
      <span className='topbar-icon-block' style={style}>
        <button className='button-link' onClick={this.openContextHelp}>
          <Awesome name='question-circle' className='icon-only' />
        </button>
      </span>
    );
  }

  get article() {
    const { location, hilfeList, custompath } = this.props;
    return _.find(hilfeList, hi => isUrlMatch(custompath || location.pathname, hi));
  }

  openContextHelp = () => {
    const { article } = this;
    const { onClick, flag_antragstellermodus: modus } = this.props;
    if (article && article.hi_text) {
      const modushilfe = modus && article.modushilfen?.length && article.modushilfen.find(mh => mh.him_astmodus == modus);
      const titel = modushilfe?.him_titel || article.hi_titel;
      const text = modushilfe?.him_text || article.hi_text;
      const content = text && converter.makeHtml(text);
      if (onClick) {
        onClick(text || "");
      } else {
        openWindow("Hilfe - e-Portal", `<h1>${ titel }</h1>${ content }`);
      }
    }
  };
}
